<template>
  <div v-if="visible" ref="floatingWindow" class="floating-window"
    :style="{ left: position.x + 'px', top: position.y + 'px' }" @mouseenter="stopAnimation"
    @mouseleave="startAnimation" @touchstart="stopAnimation" @touchend="startAnimation">
    <img src="/img/piaochuang.png" alt="飘窗" class="floating-image" />
    <div class="click-areas">
      <div class="close-area" @click="close"></div>
      <div class="detail-area" @click="handleDetail">了解详情</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const visible = ref(true);
const floatingWindow = ref(null);
const position = ref({ x: 0, y: 0 });
const velocity = ref({ x: 0, y: 0 });
let animationId = null;

const close = () => {
  visible.value = false;
  stopAnimation();
};

const handleDetail = () => {
  window.open('/henanzt', '_blank');
};

const randomDirection = () => {
  const speed = 1;
  const angle = Math.random() * 2 * Math.PI;
  return {
    x: Math.cos(angle) * speed,
    y: Math.sin(angle) * speed
  };
};

const initPosition = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  if (floatingWindow.value) {
    position.value = {
      x: (windowWidth - floatingWindow.value.offsetWidth) / 2,
      y: (windowHeight - floatingWindow.value.offsetHeight) / 2
    };
  }
  velocity.value = randomDirection();
};

const move = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const elementWidth = floatingWindow.value ? floatingWindow.value.offsetWidth : 0;
  const elementHeight = floatingWindow.value ? floatingWindow.value.offsetHeight : 0;

  position.value.x += velocity.value.x;
  position.value.y += velocity.value.y;

  let collision = false;

  if (position.value.x <= 0) {
    position.value.x = 0;
    velocity.value.x = Math.abs(velocity.value.x);
    collision = true;
  }

  if (position.value.x + elementWidth >= windowWidth) {
    position.value.x = windowWidth - elementWidth;
    velocity.value.x = -Math.abs(velocity.value.x);
    collision = true;
  }

  if (position.value.y <= 0) {
    position.value.y = 0;
    velocity.value.y = Math.abs(velocity.value.y);
    collision = true;
  }

  if (position.value.y + elementHeight >= windowHeight) {
    position.value.y = windowHeight - elementHeight;
    velocity.value.y = -Math.abs(velocity.value.y);
    collision = true;
  }

  if (collision) {
    const newDirection = randomDirection();
    const speed = Math.sqrt(velocity.value.x * velocity.value.x + velocity.value.y * velocity.value.y);
    velocity.value = {
      x: newDirection.x * speed,
      y: newDirection.y * speed
    };
  }

  animationId = requestAnimationFrame(move);
};

const stopAnimation = () => {
  if (animationId) {
    cancelAnimationFrame(animationId);
    animationId = null;
  }
};

const startAnimation = () => {
  if (!animationId) {
    animationId = requestAnimationFrame(move);
  }
};

onMounted(() => {
  initPosition();
  animationId = requestAnimationFrame(move);
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
});

onUnmounted(() => {
  stopAnimation();
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('orientationchange', handleResize);
});

const handleResize = () => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const elementWidth = floatingWindow.value ? floatingWindow.value.offsetWidth : 0;
  const elementHeight = floatingWindow.value ? floatingWindow.value.offsetHeight : 0;

  position.value.x = Math.max(0, Math.min(position.value.x, windowWidth - elementWidth));
  position.value.y = Math.max(0, Math.min(position.value.y, windowHeight - elementHeight));
};
</script>

<style lang="scss" scoped>
.floating-window {
  position: fixed;
  z-index: 9999;
  user-select: none;

  .floating-image {
    display: block;
    width: 500px;
    height: auto;
  }

  .click-areas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .close-area {
      position: absolute;
      top: 35px;
      right: 20px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    .detail-area {
      position: absolute;
      bottom: 35px;
      left: 48%;
      transform: translateX(-50%);
      width: 120px;
      height: 36px;
      background: rgba(20, 66, 145, 0.9);
      border-radius: 18px;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover,
      &:active {
        background: rgba(20, 66, 145, 1);
        box-shadow: 0 0 10px rgba(20, 66, 145, 0.8);
        transform: translateX(-50%) scale(1.05);
      }
    }
  }
}

@media (max-width: 1024px) {
  .floating-window {
    .floating-image {
      width: 350px;
    }

    .click-areas {
      .close-area {
        top: 25px;
        right: 14px;
        width: 18px;
        height: 18px;
      }

      .detail-area {
        bottom: 24px;
        width: 84px;
        height: 25px;
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 768px) {
  .floating-window {
    .floating-image {
      width: 280px;
    }

    .click-areas {
      .close-area {
        top: 20px;
        right: 11px;
        width: 16px;
        height: 16px;
      }

      .detail-area {
        bottom: 20px;
        width: 70px;
        height: 22px;
        font-size: 10px;
      }
    }
  }
}

@media (max-width: 480px) {
  .floating-window {
    .floating-image {
      width: 220px;
    }

    .click-areas {
      .close-area {
        top: 15px;
        right: 8px;
        width: 14px;
        height: 14px;
      }

      .detail-area {
        bottom: 15px;
        width: 56px;
        height: 18px;
        font-size: 9px;
      }
    }
  }
}

@media (max-width: 375px) {
  .floating-window {
    .floating-image {
      width: 180px;
    }

    .click-areas {
      .close-area {
        top: 12px;
        right: 7px;
        width: 12px;
        height: 12px;
      }

      .detail-area {
        bottom: 12px;
        width: 48px;
        height: 16px;
        font-size: 8px;
      }
    }
  }
}

@media (max-width: 320px) {
  .floating-window {
    .floating-image {
      width: 150px;
    }

    .click-areas {
      .close-area {
        top: 10px;
        right: 6px;
        width: 10px;
        height: 10px;
      }

      .detail-area {
        bottom: 10px;
        width: 42px;
        height: 14px;
        font-size: 7px;
      }
    }
  }
}
</style>